import React, { useEffect, useRef, useState } from "react";
import "./appointment.scss";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical, faEye } from "@fortawesome/free-solid-svg-icons";
import CustomModal from "../../components/common/modal/modal";
import CreateAppointment from "../../components/appointment/create-appointment";
import { appointmentStatusChange, createVisit } from "../../service/api/appointment-api";
import { useNavigate } from "react-router-dom";
import { getDashboardAppointments } from "../../store/slices/dashboardSlice";
import { formatDate, resolveActingDoctorId } from "../../utils/common-funtions/common";

const HomeAppointmentList = () => {
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState();
  const ref = useRef([]);
  const [length, setLength] = useState(5);
  // let { isLoading, pagination, allAppointments, noAppointmentFound } =
  //   useSelector((state) => state.appointment);
  let { isLoading, dashboardAppointments } = useSelector((state) => state.dashboard);
  const [show, setShow] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const navigate = useNavigate()
  const { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
  const actingDoctorId = resolveActingDoctorId({ user, selectedRole, selectedDoctor });

  useEffect(() => {
    if (selectedRole?._id) {
      dispatch(
        getDashboardAppointments({
          userRoleId: selectedRole?._id || '',
          doctorId: actingDoctorId || ""
        })
      );
    }
  }, [selectedRole?._id, selectedDoctor?._id]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // console.log("event",e,ref.current)
      if (
        selectedRow &&
        ref.current[selectedRow] &&
        !ref.current[selectedRow].contains(e.target)
      ) {
        setSelectedRow(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [selectedRow]);

  const index = () => {
    dispatch(getDashboardAppointments({ userRoleId: selectedRole?._id || '', }));
  };



  const setStatusFun = async (status, info) => {
    await appointmentStatusChange(info?._id, {
      status: status?.toLowerCase(),
    })
      .then((res) => {
        if (res.status === 200) {
          index();
          setSelectedRow();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createVisitAndNavigate = async (appointment) => {
    await createVisit(appointment?._id)
      .then((res) => {
        if (res.status === 200) {
          navigate(`/appointment/${res?.data?._id}`)
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleKeyDown = (event) => {
    // if (event.keyCode == 13) {
    //   event.preventDefault();
    //   setShow(true)
    // }
    // if (event.keyCode == 27) {
    //   event.preventDefault();
    //   setShow(false)
    // }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const initials = (name) => {
    if (!name) return "?";
    const parts = String(name).trim().split(/\s+/);
    const first = parts[0]?.[0] || "";
    const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
    return (first + last).toUpperCase() || "?";
  };

  const avatarPalette = ["#0fac81", "#0573f5", "#5b6cf3", "#e35d8a", "#e8902c", "#8957e5"];
  const avatarColor = (name) => {
    if (!name) return avatarPalette[0];
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = (hash + name.charCodeAt(i)) % avatarPalette.length;
    return avatarPalette[hash];
  };

  const titleCase = (s) => (s ? s[0].toUpperCase() + s.slice(1) : "—");

  const rows = dashboardAppointments || [];
  const showEmpty = !isLoading && rows.length === 0;

  return (
    <div>
      <div className="recent-appts-wrap">
        <table className="recent-appts">
          <thead>
            <tr>
              <th>Patient</th>
              <th>Appointment date</th>
              <th>Phone</th>
              <th>Status</th>
              <th aria-label="Actions"></th>
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr className="recent-appts__msg-row">
                <td colSpan={5}>Loading…</td>
              </tr>
            )}
            {showEmpty && (
              <tr className="recent-appts__msg-row">
                <td colSpan={5}>No appointments yet.</td>
              </tr>
            )}
            {!isLoading && rows.map((appointment) => {
              const status = appointment?.status || "pending";
              const isOpen = appointment?._id === selectedRow;
              return (
                <tr key={appointment?._id} className={isOpen ? "is-open" : ""}>
                  <td>
                    <span className="recent-appts__pat">
                      <span
                        className="recent-appts__avatar"
                        style={{ background: avatarColor(appointment?.patientName) }}
                        aria-hidden="true"
                      >
                        {initials(appointment?.patientName)}
                      </span>
                      <span className="recent-appts__pat-text">
                        <span className="recent-appts__pat-name">{appointment?.patientName || "—"}</span>
                        {appointment?.patientGender && (
                          <small className="recent-appts__pat-sub">{titleCase(appointment.patientGender)}</small>
                        )}
                      </span>
                    </span>
                  </td>
                  <td>{appointment?.date ? formatDate(appointment.date) : "—"}</td>
                  <td>{appointment?.patientPhone || "—"}</td>
                  <td>
                    <span
                      className="recent-appts__status-wrap"
                      ref={(el) => (ref.current[appointment?._id] = el)}
                    >
                      <button
                        type="button"
                        className={`recent-appts__status recent-appts__status--${status}`}
                        onClick={() => setSelectedRow(isOpen ? null : appointment?._id)}
                        aria-haspopup="menu"
                        aria-expanded={isOpen}
                      >
                        <span className="recent-appts__status-dot" aria-hidden="true" />
                        {titleCase(status)}
                        <FontAwesomeIcon
                          size="xs"
                          icon={faEllipsisVertical}
                          className="recent-appts__status-caret"
                        />
                      </button>
                      {isOpen && (
                        <div className="recent-appts__menu" role="menu">
                          <button
                            type="button"
                            className="recent-appts__menu-item"
                            onClick={() => setStatusFun("Present", appointment)}
                            role="menuitem"
                          >
                            Present
                          </button>
                          <button
                            type="button"
                            className="recent-appts__menu-item"
                            onClick={() => setStatusFun("Pending", appointment)}
                            role="menuitem"
                          >
                            Pending
                          </button>
                        </div>
                      )}
                    </span>
                  </td>
                  <td className="recent-appts__action-cell">
                    <button
                      type="button"
                      className="recent-appts__view"
                      onClick={() => createVisitAndNavigate(appointment)}
                    >
                      <FontAwesomeIcon size="sm" icon={faEye} />
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <CustomModal
        customClass="appointment"
        size="xl"
        show={show}
        setShow={setShow}
        customSize={"size-72"}
      >
        <CreateAppointment
          setShow={setShow}
          refresh={index}
        />
      </CustomModal>
    </div>
  );
};

export default HomeAppointmentList;
